// extracted by mini-css-extract-plugin
module.exports = {"logoutConfirmationModal":"confirm-logout_logoutConfirmationModal__tQGkP","description":"confirm-logout_description__KZhqp","footer":"confirm-logout_footer__KNNI_"};